import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(LanguagePl);

    /** @ngInject */
    function LanguagePl($translateProvider) {
        $translateProvider.translations('pl',
            // TRANSLATIONS
{
    "common": {
        "add": "Dodaj",
        "attachment": "Załącznik",
        "attachments": "Załączniki",
        "change": "Zmień",
        "cancel": "Anuluj",
        "close": "Zamknij",
        "closed": "Zamknięto",
        "delete": "Usuń",
        "edit": "Edytuj",
        "element_exists": "Element już istnieje",
        "filename": "Nazwa pliku",
        "hide": "Ukryj",
        "id": "ID",
        "no_results": "Brak wyników",
        "optional": "Opcjonalnie",
        "status": "Status",
        "save": "Zapisz",
        "saved": "Zapisano",
        "select": "Wybierz",
        "select_all": "Wybierz wszystkie",
        "send": "Wyślij",
        "sent": "Wysłano",
        "changes_saved": "Zapisano zmiany",
        "deleting": "Usuwanie",
        "optionally": "Opcjonalnie",
        "search": "Szukaj",
        "more": "Więcej",
        "download": "Pobierz",
        "created_at": "Data utworzenia",
        "created_by": "Utworzono przez",
        "end_date": "Data zakończenia",
        "filter_infinitive": "Filtr",
        "date": "Data",
        "date_from": "Data początkowa",
        "date_to": "Data końcowa",
        "years": "Lata",
        "months": "Miesiące",
        "days": "Dni",
        "read_more": "Czytaj więcej",
        "yes": "Tak",
        "no": "Nie"
    },
    "header": {
        "periodic_tasks": "Zadania cykliczne"
    },
    "issues": {
        "periodic_tasks_scheduler": "Planer zadań cyklicznych",
        "periodic_task_nr": "zadanie nr #{{periodic_task_id}}"
    },
    "periodic_tasks": {
        "task_list": {
            "create": "Dodaj zadanie cykliczne",
            "empty_task_list": "Brak zadań",
            "task_id": "ID",
            "client": "Klient",
            "category": "Kategoria",
            "description": "Opis",
            "frequency": "Częstotliwość",
            "start_date": "Powtarzaj od",
            "end_date": "Powtarzaj do"
        },
        "task_details": {
            "start_date": "Powtarzaj od dnia",
            "end_date": "Powtarzaj do dnia",
            "repeat": "Powtarzaj",
            "reminder_time": "Przypomnienie",
            "client": "Klient",
            "category": "Kategoria",
            "description": "Opis",
            "additional_personal_data": "Dodatkowe dane osobowe",
            "created_at": "Data dodania",
            "created_by": "Utworzono przez",
            "updated_at": "Data ostatniej modyfikacji",
            "updated_by": "Zmodyfikowano przez",
            "assets": "Zasoby",
            "locations": "Lokalizacje",
            "devices": "Urządzenia",
            "schedule": "Harmonogram",
            "history": "Historia"
        },
        "task_form": {
            "create": "Dodaj zadanie",
            "periodic_task": "Zadanie cykliczne",
            "start_date": "Powtarzaj od dnia",
            "end_date": "Powtarzaj do dnia",
            "reminder_time": "Ile dni przed terminem przypomnieć o zadaniu?"
        },
        "frequencies": {
            "every_x_days_1": "Co {{interval}} dzień",
            "every_x_days_2": "Co {{interval}} dni",
            "every_x_days_5": "Co {{interval}} dni",
            "every_x_weeks_1": "Co {{interval}} tydzień",
            "every_x_weeks_2": "Co {{interval}} tygodnie",
            "every_x_weeks_5": "Co {{interval}} tygodni",
            "every_x_months_1": "Co {{interval}} miesiąc",
            "every_x_months_2": "Co {{interval}} miesiące",
            "every_x_months_5": "Co {{interval}} miesięcy",
            "every_x_years_1": "Co {{interval}} rok",
            "every_x_years_2": "Co {{interval}} lata",
            "every_x_years_5": "Co {{interval}} lat"
        },
        "reminder": {
            "days_before_due_date_1": "{{reminderTime}} dzień przed terminem",
            "days_before_due_date_2": "{{reminderTime}} dni przed terminem",
            "days_before_due_date_5": "{{reminderTime}} dni przed terminem"
        },
        "repeater_configurator": {
            "short_months": {
                "jan": "Sty",
                "feb": "Lut",
                "mar": "Mar",
                "apr": "Kwi",
                "may": "Maj",
                "jun": "Cze",
                "jul": "Lip",
                "aug": "Sie",
                "sep": "Wrz",
                "oct": "Paź",
                "nov": "Lis",
                "dec": "Gru"
            },
            "long_months": {
                "january": "Styczeń",
                "february": "Luty",
                "march": "Marzec",
                "april": "Kwiecień",
                "may": "Maj",
                "june": "Czerwiec",
                "july": "Lipiec",
                "august": "Sierpień",
                "september": "Wrzesień",
                "october": "Październik",
                "november": "Listopad",
                "december": "Grudzień"
            },
            "repeat": "Powtarzaj",
            "daily": "Dziennie",
            "weekly": "Tygodniowo",
            "monthly": "Miesięcznie",
            "yearly": "Rocznie",
            "each": "w określone dni miesiąca",
            "on_the": "zawsze w",
            "in_which_months": "W które miesiące?",
            "in_which_days": "W które dni?",
            "every_x_days": "Co ile dni?",
            "every_x_weeks": "Co ile tygodni?",
            "every_x_months": "Co ile miesięcy?",
            "every_x_years": "Co ile lat?",
            "monday": "Poniedziałek",
            "tuesday": "Wtorek",
            "wednesday": "Środa",
            "thursday": "Czwartek",
            "friday": "Piątek",
            "saturday": "Sobota",
            "sunday": "Niedziela",
            "day": "dzień miesiąca",
            "weekday": "dzień tygodnia",
            "weekend_day": "dzień weekendu",
            "first": "pierwszy",
            "second": "drugi",
            "third": "trzeci",
            "fourth": "czwarty",
            "fifth": "piąty",
            "last": "ostatni",
            "at": "w",
            "at_the_following_days": "w następujące dni",
            "at_the_following_months": "w miesiącach"
        }
    }
}
        );
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/languages/pl.ts